<template>
	<el-config-provider :locale="locale" :size="config.size" :zIndex="config.zIndex" :button="config.button">
		<router-view></router-view>
	</el-config-provider>
</template>

<script>
import colorTool from '@/utils/color'

export default {
	name: 'App',
	data() {
		return {
			config: {
				size: "default",
				zIndex: 2000,
				button: {
					autoInsertSpace: false
				}
			}
		}
	},
	computed: {
		locale() {
			return this.$i18n.messages[this.$i18n.locale].el
		},
	},
	created() {
		//设置主题颜色
		const app_color = this.$CONFIG.COLOR || this.$TOOL.data.get('APP_COLOR')
		if (app_color) {
			document.documentElement.style.setProperty('--el-color-primary', app_color);
			for (let i = 1; i <= 9; i++) {
				document.documentElement.style.setProperty(`--el-color-primary-light-${i}`, colorTool.lighten(app_color, i / 10));
			}
			for (let i = 1; i <= 9; i++) {
				document.documentElement.style.setProperty(`--el-color-primary-dark-${i}`, colorTool.darken(app_color, i / 10));
			}


		}

		document.documentElement.style.setProperty(`--el-menu-base-level-padding`, "10px");
		document.documentElement.style.setProperty(`--el-menu-level-padding`, "20px");
		document.documentElement.style.setProperty(`--el-menu-icon-width`, "44px");
		document.documentElement.style.setProperty(`--el-menu-item-font-size`, "18px");


		// ##ERROR:  ResizeObserver loop completed with undelivered notifications.
		const debounce = (fn, delay) => {
			let timer = null;

			return function () {
				try {
					let context = this;

					let args = arguments;

					clearTimeout(timer);

					timer = setTimeout(function () {
						try {
							fn.apply(context, args);
						} catch (error2) {
							console.log(error2)
						}
					}, delay);
				} catch (error) {
					console.log(error);
				}
			};
		};

		const _ResizeObserver = window.ResizeObserver;

		window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
			constructor(callback) {
				try {
					callback = debounce(callback, 16);

				} catch (error) {
					console.log(error);
					super(callback);
					return;
				}
				super(callback);
			}
		};
		//----------------
	}
}
</script>

<style lang="scss">
 @import '@/style/style.scss';
 @import '@/style/ytable.scss';

@font-face {
	font-family: "PingFang SC";
	src: url('/public/font/pingfang/PINGFANG REGULAR.TTF');
}

@font-face {
	font-family: "Alibaba PuHuiTi 3.0";
	src: url('/public/font/AlibabaPuHuiTi-3-65-Medium.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}
// .el-form-item__label {
// 	white-space: nowrap;
// 	overflow: hidden;
// 	text-overflow: ellipsis;

// 	display:block;
// }


.el-input {
	--el-fill-color-light: rgba(233, 233, 233, 1);
	--el-border-color: rgba(233, 233, 233, 1);
	--el-text-color-disabled: rgba(233, 233, 233, 1);
	--el-border-color-hover: rgba(233, 233, 233, 1);
	--el-input-focus-border-color: rgba(233, 233, 233, 1);

	--el-fill-color-blank: rgba(233, 233, 233, 1);
	/* --el-text-color-regular:green;
	--el-select-input-color:green !important;
	--el-text-color-placeholder:green; */
}

.el-select {
	--el-fill-color-light: rgba(233, 233, 233, 1);
	--el-border-color: rgba(233, 233, 233, 1);
	--el-text-color-disabled: rgba(233, 233, 233, 1);
	--el-border-color-hover: rgba(233, 233, 233, 1);
	--el-input-focus-border-color: rgba(233, 233, 233, 1);
	--el-fill-color-blank: rgba(233, 233, 233, 1);
	--el-color-primary: #4BBFBE

}

body {
	--el-font-size-base: 14px;

	--max-margin-top: 18px;
	--min-margin-top: 12px;

	--color-gray1: #333;
	--color-gray2: #666;
	--color-gray3: #999;

	--font-size-1: 24px;
	--font-size-2: 20px;
	--font-size-3: 18px;
	--font-size-4: 16px;
	--font-size-5: 14px;
	--font-size-6: 12px;

	letter-spacing: 0.02em;
}

.table-head-title {
	width: 100%;
	// margin-top: 20px;

	font-family: PingFang SC, PingFang SC;
	font-weight: bold;
	font-size: 24px;
	color: #333333;
	line-height: 0px;
	text-align: left;
	font-style: normal;
	text-transform: none;
	padding-left: 15px;
	background-color: #fff;
	height: 50px;
	line-height: 50px;
}

.button_backgroup {
	// background: linear-gradient(rgba(81, 193, 155, 1), rgba(69, 154, 125, 1));
	border: none;

	color: #FFF;
	text-align: center;
	font-family: "Alibaba PuHuiTi 3.0";
	font-size: 16px; 
	font-weight: 500; 
	height: 32px;
	line-height: 32px;
}


.button_backgroup2 {
	// background: linear-gradient(rgba(81, 193, 155, 1), rgba(69, 154, 125, 1));
	border: none;

	color: #FFF;
	text-align: center;
	font-family: "Alibaba PuHuiTi 3.0";
	font-size: 16px; 
	font-weight: 500; 
	height: 32px;
	line-height: 32px;
}
 
 

.conditionlist{
	display: flex;
	align-items: center;
	justify-content: center;
}

.conditionlable{
	width: auto;
	white-space: nowrap; /* 防止文字换行 */
	padding: 0 5px 0 5px;
	color: #000;
	text-align: center;

	/* 正文 */
	font-family: "Alibaba PuHuiTi 3.0";
	font-size: 15px; 
	// font-weight: 500; 
}

.serach_input{
	width: 220px;
	background: #fff;
}
</style>
